import React from 'react'

const Orange = () => {
  return (
    <div className='h-screen w-full max-w-[1240px] mx-auto text-center flex flex-col justify-center'>
        <p>
        I'm a dedicated software engineer fueled by a passion for turning
         intricate ideas into functional, user-centric solutions. Proficient in various programming languages and armed with a keen eye for detail, I specialize in creating robust, scalable applications. My experience spans both front-end and back-end development, allowing me to craft seamless experiences while ensuring efficient system architecture. I thrive in collaborative environments, embracing challenges as opportunities to learn and innovate. My goal is to continuously evolve, contributing positively to technological advancements
         while delivering impactful solutions that resonate with users.
        </p>
    </div>
  )
}

export default Orange